// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"d96b31b4","182":"82884b55","453":"f5b344b3"}[chunkId] + ".chunk.js";
};